import { render } from "./RelatedItemLine.vue?vue&type=template&id=c6bd2d2c&scoped=true&ts=true"
import script from "./RelatedItemLine.vue?vue&type=script&lang=ts"
export * from "./RelatedItemLine.vue?vue&type=script&lang=ts"

import "./RelatedItemLine.vue?vue&type=style&index=0&id=c6bd2d2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6bd2d2c"]])

export default __exports__